import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rzm-footer',
    templateUrl: './rzm-footer.component.html',
    styleUrls: ['./rzm-footer.component.scss'],
    standalone: false
})
export class RzmFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
